module.exports = __webpack_public_path__ + "static/img/2-4-普通补发.1b3d3ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-4-普通补发.png
// module id = 1316
// module chunks = 0